// src/services/ChatbotService.js

const BASE_URL = "https://isir.ai/chatbot/api";

export async function login(username, password) {
  const res = await fetch(`${BASE_URL}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include", // Ensures cookies are sent
    body: JSON.stringify({ username, password }),
  });
  return res.json();
}

export async function signup(username, password) {
  const res = await fetch(`${BASE_URL}/signup`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  return res.json();
}

export async function logout() {
  const res = await fetch(`${BASE_URL}/logout`, {
    method: "POST",
    credentials: "include",
  });
  return res.json();
}

export async function submitQuery(query) {
  const res = await fetch(`${BASE_URL}/query`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ query }),
  });
  return res.json();
}

export async function fetchHistory() {
  const res = await fetch(`${BASE_URL}/history`, {
    method: "GET",
    credentials: "include",
  });
  return res.json();
}
